// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2Y4CM","buttons":"Footer_buttons__1HbBS"};